import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import useHideOnSite from '../../../hooks/useLanguageFilter';

const Quiz = ({ blok }) => {
  if (useHideOnSite(blok.hide_on_site)) return null;

  return (
    <div
      className="w-full col-span-12 grid grid-cols-subgrid mt-8"
      {...storyblokEditable(blok)}
    >
      {blok?.questions?.map((q) => (
        <StoryblokComponent blok={q}></StoryblokComponent>
      ))}
      {blok?.results?.map((result) => (
        <StoryblokComponent blok={result} />
      ))}
    </div>
  );
};

export default Quiz;
